import { render, staticRenderFns } from "./MyInvestorAccountTab.vue?vue&type=template&id=41a12950"
import script from "./MyInvestorAccountTab.vue?vue&type=script&lang=js"
export * from "./MyInvestorAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports